import { createSlice } from "@reduxjs/toolkit";
import {
  getPayments,
  addNewPayment,
  updatePayment,
  deletePayment,
  getPaymentById,
} from "./thunk";

export const initialState = {
  payments: [],
  error: {},
  selectedPayment: null,
  isPaymentSuccess: false,
  isPaymentCreated: false,
};

const paymentsSlice = createSlice({
  name: "PaymentsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch payments
    builder.addCase(getPayments.fulfilled, (state, action) => {
      state.payments = action.payload; // Assuming `action.payload` contains payment data
      state.isPaymentSuccess = true;
      state.error = null;
    });

    builder.addCase(getPayments.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch payments";
      state.isPaymentSuccess = false;
    });
    // Fetch a single payment by ID
    builder.addCase(getPaymentById.fulfilled, (state, action) => {
      state.selectedPayment = action.payload; // Set the selected payment
      state.error = null;
    });

    builder.addCase(getPaymentById.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch payment by ID";
      state.selectedPayment = null; // Clear the selected payment on failure
    });

    // Add new payment
    builder.addCase(addNewPayment.fulfilled, (state, action) => {
      state.payments.push(action.payload); // Add the new payment to the list
      state.isPaymentCreated = true;
      state.error = null;
    });

    builder.addCase(addNewPayment.rejected, (state, action) => {
      state.error = action.payload || "Failed to add payment";
      state.isPaymentCreated = false;
    });

    // Update payment
    builder.addCase(updatePayment.fulfilled, (state, action) => {
      state.payments = state.payments.map((payment) =>
        payment.id === action.payload.id ? { ...payment, ...action.payload } : payment
      );
      state.error = null;
    });

    // Delete payment
    builder.addCase(deletePayment.fulfilled, (state, action) => {
      state.payments = state.payments.filter(
        (payment) => payment.id !== action.payload.paymentId
      );
      state.error = null;
    });

    builder.addCase(deletePayment.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to delete payment";
    });
  },
});

export default paymentsSlice.reducer;
